import React, { Component } from 'react';
import { TheaterCard } from '../../components/Cards';

class TheaterGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAll: false,
      limit: this.props.limit,
    };
  }

  onShowAllChange() {
    this.setState({
      showAll: !this.state.showAll,
      limit: !this.state.limit,
    });
  }

  chunks(arr, size) {
    if (!Array.isArray(arr)) {
      throw new TypeError('Input should be Array');
    }

    if (typeof size !== 'number') {
      throw new TypeError('Size should be a Number');
    }

    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, size + i));
    }

    return result;
  }

  renderShowMore(show) {
    const classes =
      'text-center col-md-2 col-md-offset-5 col-xs-4 col-xs-offset-4 button bordered-tmp-button';
    const isShowMoreNecessary =
      this.props.theaters &&
      this.props.theaters.length > (this.props.limitTo || 3) &&
      this.props.limit;

    if (isShowMoreNecessary) {
      if (show && !this.state.showAll) {
        return (
          <div onClick={() => this.onShowAllChange()} className={classes}>
            Ver todos
          </div>
        );
      }
      return (
        <div onClick={() => this.onShowAllChange()} className={classes}>
            Ver menos
        </div>
      );
    } return <div />;
  }

  render() {
    let {
      theaters, animate, limitTo, showMore,
    } = this.props;
    if (!theaters) {
      theaters = [];
    }

    if (this.state.limit && theaters) {
      theaters = [...theaters.slice(0, limitTo)];
    }


    const rows = this.chunks(theaters, 3);
    let count = 0;

    return (
      <div>
        <div className="row">
          {rows.map((row) => {
            count += 1;

            return (
              <div key={count} className="row">
                {row.map(col => (
                  <TheaterCard
                    animate={animate}
                    key={col.id}
                    theater={col}
                  />
                ))}
              </div>);
          })}
        </div>
        <div className="row">{this.renderShowMore(showMore)}</div>
      </div>
    );
  }
}

export default TheaterGrid;



// WEBPACK FOOTER //
// ./src/containers/theaters/TheaterGrid.js